import { ProxyResponse } from "../../../../../../common/api/master-api/cloud-files/get-proxies/GetCloudFileProxiesResponse";
import { Trimming } from "../../../../../../common/api/master-api/qc/TrimmingResponse";

export interface ProxyItem {
    id: string;
    encoding: string;
    filePath: string;
    fileName: string;
    details: ProxyDetails | undefined;
}

export type ProxyDetails = TrimmedProxyDetails;

interface TrimmedProxyDetails {
    trimming: Trimming;
}

export const mapToProxyItem = (response: ProxyResponse): ProxyItem => {
    return {
        id: response.id,
        encoding: response.encoding,
        filePath: response.filePath,
        fileName: response.fileName,
        details: response.details
    };
};
